import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/close.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center fixed inset-y-0 right-0 overflow-x-hidden overflow-y-hidden z-50 w-full"
}
const _hoisted_2 = { class: "flex relative w-1/2 h-auto" }
const _hoisted_3 = { class: "flex flex-col bg-white w-full h-auto rounded-2xl shadow p-8" }
const _hoisted_4 = { class: "flex flex-row justify-between mb-8" }
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-lg mb-8" }, "Select a cause and leave a justification comment", -1)
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Select a cause "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "(Required)")
], -1)
const _hoisted_12 = { class: "flex flex-col mt-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Dismissal date "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "(Required)")
], -1)
const _hoisted_14 = { class: "flex flex-col mt-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Leave a jutification comment "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "(Required)")
], -1)
const _hoisted_16 = { class: "flex flex-col mt-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-lg mb-4" }, "Severance", -1)
const _hoisted_18 = { class: "flex flex-row items-center" }
const _hoisted_19 = { class: "w-1/2" }
const _hoisted_20 = { class: "w-1/2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-300 h-px w-full my-8" }, null, -1)
const _hoisted_22 = { class: "flex flex-row items-center justify-end" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 1,
  class: "bg-black opacity-50 fixed inset-y-0 right-0 z-40 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectDropdown = _resolveComponent("SelectDropdown")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_CurrencyFieldSimple = _resolveComponent("CurrencyFieldSimple")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.talent_name), 1),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_SelectDropdown, {
                    modelValue: _ctx.cause,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cause) = $event)),
                    label: "Cause...",
                    options: _ctx.causes,
                    name: "cause"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_DatePicker, {
                    placeholder: "Dismissal date",
                    name: "dismissal_date",
                    minDate: _ctx.minDate
                  }, null, 8, ["minDate"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_TextArea, {
                    placeholder: "Write a justification comment...",
                    name: "justification"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_CurrencyFieldSimple, {
                      modelValue: _ctx.amount,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.amount) = $event)),
                      placeholder: "Amount",
                      class: "bg-background rounded px-4 py-5 mr-4"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_SelectDropdown, {
                      modelValue: _ctx.currency,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currency) = $event)),
                      label: "Currency",
                      options: _ctx.currencyOptions,
                      name: "currency"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ])
              ]),
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                  disabled: _ctx.canSubmit,
                  class: _normalizeClass(["disabled:opacity-50 disabled:cursor-not-allowed", {
                'btn-filled-lg': !_ctx.loading,
                'btn-filled-lg-loading': _ctx.loading,
              }])
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Continue"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_25, "Loading..."))
                ], 10, _hoisted_23)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26))
      : _createCommentVNode("", true)
  ]))
}